import '@cash-design-system/react' // Just for the darkMode type on Theme object.

import { EmojiIconId } from './emojis'
import { getEmojiSvg } from './getEmojiSvg'

const unicodeToEmojiIconIdMap: { [key: string]: EmojiIconId } = {
  '💰': 'EXTRA_CASH',
  '🏝': 'VACATION',
  '🎁': 'GIFT',
  '🎓': 'EDUCATION',
  '🏡': 'LIVING',
  '☔️': 'RAINY_DAY',
  '🎂': 'BIRTHDAY',
  '🤒': 'ILLNESS',
  '🎮': 'GAMES',
  '🍴': 'FOOD',
  '💻': 'TECHNOLOGY',
  '✈️': 'TRAVEL',
} as const

/**
 * Prefer `getEmojiSvg` when an icon ID is available, otherwise fallback to this for unicode support.
 */
export function unicodeToEmojiSvg({
  unicode,
  size,
  darkMode,
}: {
  unicode: string
  size: 24 | 48
  darkMode: boolean
}): string {
  const iconId = unicodeToEmojiIconIdMap[unicode]

  if (!iconId) {
    throw Error(`No emoji icon ID found for unicode "${unicode ?? 'undefined'}"`)
  }

  return getEmojiSvg({ iconId, size, darkMode })
}
